// extracted by mini-css-extract-plugin
module.exports = {"root":"az_Z0","disabled":"az__0","edgeStart":"az_a1","edgeEnd":"az_b1","colorInherit":"az_c1","colorPrimary":"az_d1","colorSecondary":"az_e1","sizeSmall":"az_f1","label":"az_g1"};